// File: /src/components/Header.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Sun, Moon, LogOut } from 'lucide-react';
import NavMenu from './Sidebar';
import '../styles/Header.css';
import logo from '../assets/locatime.png';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

function Header() {
	const { isAuthenticated, logout } = useAuth();
	const { isDarkMode, toggleTheme } = useTheme();
	const navigate = useNavigate();

	if (!isAuthenticated) return null;

	const handleLogout = () => {
		logout();
		navigate('/login');
	};

	const handleThemeToggle = () => {
		// Toggle between light and dark (ignore system preference when manually toggling)
		const newTheme = isDarkMode ? 'light' : 'dark';
		toggleTheme(newTheme);
	};

	return (
		<header className="header">
			<div className="header-container">
				<div className="header-left">
					<NavMenu />
					<Link to="/" className="logo">
						<img src={logo} alt="LocaTime" className="logo-image" />
					</Link>
				</div>
				
				<div className="header-right">
					<button
						className="header-theme-btn"
						onClick={handleThemeToggle}
						title={isDarkMode ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
						aria-label={isDarkMode ? 'Ativar tema claro' : 'Ativar tema escuro'}
					>
						{isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
					</button>
					
					<button
						className="header-action-btn header-logout-btn"
						onClick={handleLogout}
						title="Sair da conta"
						aria-label="Sair"
					>
						<LogOut size={16} className="header-logout-icon" />
						<span>Sair</span>
					</button>
				</div>
			</div>
		</header>
	);
}

export default Header;
